var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "",
    height: "",
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.25H2.25C1.62891 11.25 1.09863 11.0303 0.65918 10.5908C0.219727 10.1514 0 9.62109 0 9C0 8.37891 0.219727 7.84863 0.65918 7.40918C1.09863 6.96973 1.62891 6.75 2.25 6.75H15.75C16.3711 6.75 16.9014 6.96973 17.3408 7.40918C17.7803 7.84863 18 8.37891 18 9C18 9.62109 17.7803 10.1514 17.3408 10.5908C16.9014 11.0303 16.3711 11.25 15.75 11.25ZM15.75 4.5H2.25C1.62891 4.5 1.09863 4.28027 0.65918 3.84082C0.219727 3.40137 0 2.87109 0 2.25C0 1.62891 0.219727 1.09863 0.65918 0.65918C1.09863 0.219727 1.62891 0 2.25 0H15.75C16.3711 0 16.9014 0.219727 17.3408 0.65918C17.7803 1.09863 18 1.62891 18 2.25C18 2.87109 17.7803 3.40137 17.3408 3.84082C16.9014 4.28027 16.3711 4.5 15.75 4.5ZM2.25 13.5H15.75C16.3711 13.5 16.9014 13.7197 17.3408 14.1592C17.7803 14.5986 18 15.1289 18 15.75C18 16.3711 17.7803 16.9014 17.3408 17.3408C16.9014 17.7803 16.3711 18 15.75 18H2.25C1.62891 18 1.09863 17.7803 0.65918 17.3408C0.219727 16.9014 0 16.3711 0 15.75C0 15.1289 0.219727 14.5986 0.65918 14.1592C1.09863 13.7197 1.62891 13.5 2.25 13.5Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.2d6c3092241747cea77e3a064a247b2a.svg";
export { ForwardRef as ReactComponent };